<template>
  <div>
    <!-- 内容· -->
    <div class="backwhite width100 margin-auto">
      <div class="pad-bot20">
        <p class="f16 width98 textalign-left dimensional">新增融资</p>
      </div>

      <div class="bg-box">
        <p class="width100 textalign-left pad-bot5">项目名称</p>
        <div class="box-right">
          <el-input
            class="inputDeep"
            placeholder="请输入项目名称"
            v-model="title"
          ></el-input>
        </div>
      </div>

      <div class="bg-box">
        <p class="width100 textalign-left pad-bot5">融资时间</p>
        <div class="box-right">
          <el-date-picker
            class="inputDeep"
            v-model="finance_date"
            type="date"
            placeholder="请选择研发融资时间"
            value-format="yyyy-MM-dd"
            :editable="false"
          ></el-date-picker>
        </div>
      </div>

      <div class="bg-box">
        <p class="width100 textalign-left pad-bot5">融资金额</p>
        <div class="box-right">
          <el-input
            type="number"
            class="inputDeep"
            placeholder="请输入融资金额 单位为万元"
            v-model="fund"
          />
        </div>
      </div>

      <div class="bg-box">
        <p class="width100 textalign-left pad-bot5">融资利率</p>
        <div class="box-right">
          <el-input
            class="inputDeep"
            placeholder="请输入利率 如 0.002"
            v-model="interest_rate"
          />
        </div>
      </div>

      <div class="bg-box">
        <p class="width100 textalign-left pad-bot5">投资机构</p>
        <div class="box-right">
          <el-input
            class="inputDeep"
            placeholder="请输入融资机构名称"
            v-model="institution"
          />
        </div>
      </div>
      <div class="bg-box">
        <p class="width100 textalign-left pad-bot5">融资方式</p>

        <el-select
          class="inputDeep box-right"
          v-model="way"
          placeholder="请选择融资方式"
          :filterable="true"
        >
          <el-option label="---  请选择  ---" value=""></el-option>
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="bg-box">
        <p class="width100 textalign-left pad-bot5">融资货币</p>

        <el-select
          v-model="currency"
          class="inputDeep box-right"
          placeholder="请选择货币类型"
          :filterable="true"
        >
          <el-option label="---  请选择  ---" value=""></el-option>
          <el-option
            v-for="item in optionss"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>

      <div class="bg-box">
        <p class="width100 textalign-left pad-bot5">到期时间</p>
        <div class="box-right">
          <el-date-picker
            class="inputDeep"
            v-model="end_time"
            type="date"
            placeholder="请选择到期时间"
            value-format="yyyy-MM-dd"
            :editable="false"
          ></el-date-picker>
        </div>
      </div>

      <div class="bg-box">
        <p class="width100 textalign-left pad-bot5">融资备注</p>
        <div class="box-right">
          <el-input
            type="textarea"
            :autosize="autosize"
            v-model="remark"
            placeholder="请输入项目备注"
            class="inputDeep"
            maxlength="500"
            rows="5"
            cols="20"
          ></el-input>
        </div>
      </div>
      <div class="textalign-right margin-top20">
        <el-button @click="dialognull()">取 消</el-button>
        <el-button type="primary" @click="Savechanges()"> 保 存 </el-button>
      </div>
    </div>

    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="30%"
      class="errorbox"
    >
      <span class="errormessage">{{ errormessage }}</span>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
  
  <script>
import { entfinancesave } from "@/api/business/business.api";
import BUS from "@/BUS/BUS";
export default {
  data() {
    return {
      autosize: {
        minRows: 3,
        maxRows: 1000,
      },
      errormessage: "",
      dialogVisiblenull: false,

      options: [
        {
          value: 1,
          label: "银行贷款",
        },
        {
          value: 2,
          label: "小贷公司贷款",
        },
        {
          value: 3,
          label: "P2P融资",
        },
        {
          value: 4,
          label: "融资租赁",
        },
        {
          value: 5,
          label: "股票筹资",
        },
        {
          value: 6,
          label: "债务融资",
        },
        {
          value: 7,
          label: "信用担保融资",
        },
        {
          value: 8,
          label: "股权融资",
        },
        {
          value: 9,
          label: "增资扩股",
        },
        {
          value: 10,
          label: "产权交易",
        },
        {
          value: 11,
          label: "票据贴现",
        },
        {
          value: 12,
          label: "贸易融资",
        },
        {
          value: 13,
          label: "供应链融资",
        },
        {
          value: 14,
          label: "信托融资",
        },
      ],
      optionss: [
        {
          value: 1,
          label: "人民币",
        },
        {
          value: 2,
          label: "美元",
        },
        {
          value: 3,
          label: "其它",
        },
      ],
      title: "",
      institution: "",
      finance_date: "",
      way: "",
      currency: "",
      fund: "",
      interest_rate: "",
      end_time: "",
      remark: "",
    };
  },

  methods: {
    Savechanges() {
      entfinancesave({
        title: this.title,
        institution: this.institution,
        finance_date: this.finance_date,
        way: this.way,
        currency: this.currency,
        fund: this.fund,
        interest_rate: this.interest_rate,
        end_time: this.end_time,
        remark: this.remark,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            showClose: true,
            message: "添加成功",
            type: "success",
          });

          BUS.$emit("financingadd", "yes");
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    dialognull() {
      BUS.$emit("financingadd", "yess");
    },
    callback() {
      window.history.back();
    },
  },

  created() {},
};
</script>
  
  <style scoped>
.inputDeep {
  text-align: right;
}
/* 表单盒子 */
.bg-box {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  padding: 10px 0 0 0;
  color: #4f4f4f;
  font-size: 14px;
}
.but-box {
  width: 50%;
  margin: 20px auto 0;
}

.box-right {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
}
.button {
  width: 60px;
  height: 26px;
  font-size: 14px;
  color: white;
  background: #a4adb3;
  border: none;
  border-radius: 5px;
}

::placeholder {
  color: #a4a4a4;
  font-size: 12px;
}
.el-input {
  width: 100%;
}
.textarea >>> .el-textarea__inner {
  width: 120%;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>
  